import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { newProveedorSchema } from '@/shared';
import { useCreateGroupProovedores, useUpdateGroupProovedores } from '@/shared/actions/erp';
import {
    
    CustomTextField,
    ModelStateSelect,
    SingleFormBoxScene,
  } from '@/shared/components/ui';
import { GROUPPROVEEDORES } from '@/shared/interfaces';
 
const returnUrlGrupoProveedor = '/compras/grupo-proveedores';

export interface SaveProveedorInterface {
  titlePage: string;
  editProveedor?: GROUPPROVEEDORES;
}
 
type SaveFormData = {
    nombre:string;
    descripcion:string;
    estado:boolean;
};
 
const SaveGroupProveedor: React.FC<SaveProveedorInterface> = ({ titlePage, editProveedor }) => {
    const navigate = useNavigate();
    const [shrink, setShrink] = useState(false);
    ///* mutations
    const createProveedorMutation = useCreateGroupProovedores({navigate, returnUrl:returnUrlGrupoProveedor});
    const updateProveedorMutation = useUpdateGroupProovedores({navigate, returnUrl:returnUrlGrupoProveedor});
    ///* form
    const form = useForm<SaveFormData>({
        resolver: yupResolver(newProveedorSchema),
    });
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors, isValid },
    } = form;
    ///* handlers
    const onSave = () => {
        if (!isValid) return;
        ///* upd
        if (editProveedor?.id_grupo_proveedor) {
            return updateProveedorMutation.mutate({
                id: editProveedor.id_grupo_proveedor,
                data: form.getValues() as any, // percent
            });
        }
        ///* create
        createProveedorMutation.mutate(form.getValues() as any);
    };
    ///* effects
    useEffect(()=>{
        if(editProveedor){
            setShrink(true);
            reset({
                nombre: editProveedor.nombre,
                descripcion: editProveedor.descripcion,
                estado:!!editProveedor.estado? '1' : '0',
            } as any);
        }
    },
    [editProveedor]
    );
    return (
        <SingleFormBoxScene
            titlePage={titlePage}
            onCancel={() => {
                navigate(returnUrlGrupoProveedor);
            }}
            onSave={handleSubmit(onSave)}
            >
                 <CustomTextField
                name="nombre"
                label="Nombre"
                control={form.control}
                defaultValue={form.getValues().nombre || ""}
                error={errors.nombre}
                helperText={errors.nombre?.message}
                shrink={shrink}
              />
               <CustomTextField
                name="descripcion"
                label="Descripcion"
                control={form.control}
                defaultValue={form.getValues().descripcion || ""}
                error={errors.descripcion}
                helperText={errors.descripcion?.message}
                shrink={shrink}
              />
                {/* ====== state ====== */}
                <ModelStateSelect
                    defaultValue={form.getValues().estado || ''}
                    register={register('estado')}
                    error={errors.estado}
                    helperText={errors.estado?.message}
                />
    
            </SingleFormBoxScene>

    
  );
};
export default SaveGroupProveedor;
